import React from 'react';
import { Redirect } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import ProfileConfig from 'app/main/profile/Profile.config';
import ClientsConfig from 'app/main/clients/Clients.config';
import UserConfig from 'app/main/users/User.config';
import AdminConfig from 'app/main/admin/Admin.config';
import HomeConfig from 'app/main/home/HomeConfig';
import ApplicationsConfig from 'app/main/applications/Applications.config';
import RolesConfig from 'app/main/roles/Roles.config';
import TranslationsConfig from 'app/main/translations/Translations.config';

const routeConfigs = [
  ProfileConfig,
  ApplicationsConfig,
  ClientsConfig,
  UserConfig,
  AdminConfig,
  HomeConfig,
  RolesConfig,
  TranslationsConfig
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    component: () => <Redirect to="/home" />
  }
];

export default routes;
